import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Bell, Loader2 } from "lucide-react";
import { web, errMsg } from "../../lib/api";

const MSG = {
  check_email: "Check your email and click the link to confirm.",
  already_following: "You already get final scores for this team.",
  confirmed: "You're following this team.",
  unsubscribed: "You're unsubscribed.",
};

/** Fans enter an email to get final scores (confirmed by email link). */
export const FanFollow = ({ slug, teamName }) => {
  const [params, setParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState("");
  useEffect(() => {
    if (params.get("followed")) { setStatus("confirmed"); toast.success(`You'll get ${teamName ?? "this team"}'s final scores by email`); }
    if (params.get("unsubscribed")) { setStatus("unsubscribed"); toast.success("Unsubscribed. No more final-score emails."); }
    if (params.get("followed") || params.get("unsubscribed")) setParams({}, { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await web.post(`/public/teams/${slug}/follow`, { email }); setStatus(data?.status ?? "check_email"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="fan-follow" className="rounded-2xl border border-[#39FF14]/30 bg-[#39FF14]/5 p-4 sm:p-5">
      <p className="flex items-center gap-2 font-display text-xl font-black uppercase text-white"><Bell className="h-5 w-5 text-[#39FF14]" />Get final scores</p>
      <p className="mt-1 text-sm text-slate-300">We'll email you the score and top scorer after each game. Unsubscribe anytime.</p>
      {status !== "confirmed" && (
        <form onSubmit={submit} className="mt-3 flex flex-col gap-2 sm:flex-row">
          <input data-testid="fan-follow-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
            className="w-full rounded-full border border-[#1E293B] bg-[#0F172A] px-4 py-2.5 text-sm text-white placeholder:text-slate-500" />
          <button data-testid="fan-follow-submit" disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#39FF14] px-5 py-2.5 text-sm font-bold text-[#0A0E1A] disabled:opacity-50">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Follow team
          </button>
        </form>
      )}
      {MSG[status] && <p data-testid="fan-follow-status" className={`mt-2 text-sm ${status === "confirmed" ? "font-semibold text-[#39FF14]" : "text-slate-200"}`}>{MSG[status]}</p>}
    </div>
  );
};
